import { render, staticRenderFns } from "./TeacherAndEvaluateBar.vue?vue&type=template&id=c20a76b6&scoped=true"
import script from "./TeacherAndEvaluateBar.vue?vue&type=script&lang=js"
export * from "./TeacherAndEvaluateBar.vue?vue&type=script&lang=js"
import style0 from "./TeacherAndEvaluateBar.vue?vue&type=style&index=0&id=c20a76b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20a76b6",
  null
  
)

export default component.exports